<template>
  <div>
      <ServerError v-if="ServerError" />
      <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
      <v-layout wrap pl-3 pl-md-7 py-7>
          <v-flex xs12 pt-6 pb-3>
              <div><span class="clr">SELLER PORTAL</span></div>
              <div>
               <span class="head">Top Selling Products</span>
              </div>
          </v-flex>
          <v-flex lg7>
  
    <v-layout wrap v-for="(item, i) in top" :key="i" py-2>
      <v-flex xs12 sm2 md2 pb-3 pb-md-0>
        <v-img
          v-if="item.product.photos[0].length < 1"
          height="100px"
          contain
          src="../../../assets/images/m1.png"
        >
        </v-img>
        <v-img
          v-else
          height="100px"
         contain
          :src="mediaURL + item.product.photos[0]"
        >
        </v-img>
      </v-flex>
      <v-flex pl-1 xs10 align-self-center>
        <v-layout wrap pl-lg-3>
          <v-flex xs7 sm5 md6>
            <div class="medium clr RG">{{ item.product.productName }}</div>
            <div class="RB medium">Price: ₹{{ item.product.price }} per Kg</div>
          </v-flex>
          <v-flex xs5 sm3 md2>
            <div class="medium clr RG">Sold Quantity</div>
            <div class="RB medium">{{ item.soldQuantity }}KG</div>
          </v-flex>
          <v-flex xs6 sm2 md2 pt-3 pt-sm-0 pt-md-0>
            <div class="medium clr RG">Today</div>
            <div class="RB medium">₹{{ item.todaySale }} /-</div>
          </v-flex>
          <v-flex xs6 sm2 md2 pt-3 pt-sm-0 pt-md-0>
            <div class="medium clr RG">Total Sale</div>
            <div class="RB medium">₹{{ item.totalSale }}</div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
     </v-flex>
      </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      top: [],
      todaysale: "",
      totalsale: "",
      appLoading:false,
      ServerError:false
    };
  },
  mounted()
  {
this.topProduct();
  },
  methods: {
    topProduct() {
   this.appLoading =true
      axios({
        method: "post",
        url: "/seller/topselling/products/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          
            this.top = response.data.data;
         
        }
        this.appLoading =false
      })
      .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
